













import { defineClassComponent, useQuery } from '@/hooks'
import { GroupBuyingComponents } from './components'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: GroupBuyingComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '拼团-支付结果',
        }))
      }

      query = useQuery<{
        /** 团单ID */
        id: string
      }>()
    },
)
